import { SHOW_TOGGLE, HIDE_TOGGLE, SWITCH_TOGGLE } from '../actionTypes'
import ReactGA from 'react-ga'

export const showToggle = panel => ({ type: SHOW_TOGGLE, payload: { panel } })
export const hideToggle = panel => ({ type: HIDE_TOGGLE, payload: { panel } })
export const switchToggle = panel => ({
  type: SWITCH_TOGGLE,
  payload: { panel }
})

export const togglesReducer = (
  state = {},
  { type, payload }
) => {
  let newState = state
  switch (type) {
    case SHOW_TOGGLE:
      newState = { ...state, [payload.panel]: true }
      break
    case HIDE_TOGGLE:
      newState = { ...state, [payload.panel]: false }
      break
    case SWITCH_TOGGLE:
      newState = { ...state, [payload.panel]: !state[payload.panel] }
      break
    default:
  }

  // if a panel has changed
  if (
    payload &&
    payload.panel &&
    newState[payload.panel] !== state[payload.panel]
  ) {
    const names = {
      activity: 'Activity',
      queue: 'Queue',
      discuss: 'Discuss'
    }
    ReactGA.event({
      category: names[payload.panel],
      action: newState[payload.panel]
        ? `Open ${names[payload.panel]}`
        : `Close ${names[payload.panel]}`
    }, ['app'])
  }

  return newState
}
